<template>
  <span class="terms__agree">
    <IconComponent name="tick-circle" />
    <span>
      Согласен с
      <a
        href="/static/documents/4_Пользовательское_соглашение.pdf"
        target="_blank"
        >пользовательским соглашением</a
      >
    </span>
  </span>
</template>

<script>
import IconComponent from "components/IconComponent.vue";

export default {
  name: "TermsAgreeComponent",
  components: { IconComponent },
};
</script>

<style lang="stylus">
.terms__agree {
  margin-top: 10px;
  color var(--main-color)
  display flex
  font-size: 0.75em
  line-height: 18px;
  gap 5px

  a {
    text-decoration underline
		color var(--main-color)
  }

  .icon {
    width 12px
    height 12px
    margin-top: 2px;

    svg path {
      stroke var(--main-color-75)
    }
  }
}
</style>
